import api from '../api/client';

export interface ReverseGeocodeResult {
  address: string;
  street?: string;
  houseNumber?: string;
  postcode?: string;
  city?: string;
  country?: string;
}

/**
 * Hämta adress för en punkt (reverse geocoding).
 * Används t.ex. för att fylla adressfält från ritat geofence-område.
 */
export async function reverseGeocode(lat: number, lon: number): Promise<ReverseGeocodeResult | null> {
  const res = await api.get<{ success: boolean; data: ReverseGeocodeResult | null }>(
    '/api/geocoding/reverse',
    { params: { lat, lon } }
  );
  if (!res.data.success || res.data.data == null) return null;
  return res.data.data;
}

export interface ForwardGeocodeResult {
  lat: number;
  lon: number;
  address: string;
  name?: string;
  street?: string;
  houseNumber?: string;
  city?: string;
  postcode?: string;
  country?: string;
}

/**
 * Sök adress/plats → koordinater (forward geocoding). Valfri lat/lon biaserar
 * resultaten mot en plats (t.ex. fordonets placering).
 */
export async function searchAddress(
  q: string,
  opts: { lat?: number; lon?: number; limit?: number } = {}
): Promise<ForwardGeocodeResult[]> {
  if (q.trim().length < 2) return [];
  const res = await api.get<{ success: boolean; data: ForwardGeocodeResult[] }>(
    '/api/geocoding/search',
    { params: { q, ...opts } }
  );
  if (!res.data.success || !Array.isArray(res.data.data)) return [];
  return res.data.data;
}
